<template>
    <div>
        <section-header heading="2" ja="このプリクラはダウンロード済みです" />
        <!-- 無料会員 -->
        <template v-if="membershipGrade === 1 && sheets && sheets.length > 0">
            <div class="puriTopWrapper --marginTop">
                <puri-contents-top
                    :selected-contents=selectedContents
                    :membership-grade=membershipGrade
                    :limit-date=limitDate
                    :create-date=createDate
                    :arcade-logo-img=arcadeLogoImg
                />
            </div>
        </template>
        <!-- 有料会員 -->
        <template v-else-if="membershipGrade >= 2 && sheets && sheets.length > 0">
            <div v-for="(sheets, i) in sheetsList" :key="i">
                <puri-sheet
                    v-for="s in sheets"
                    :key="s.id"
                    :arcade-name=s.arcadeName
                    :create-date=s.createDate
                    :limit-date=s.limitDate
                    :puri-list=s.puriList
                    :arcade-logo-img=s.arcadeLogoImg
                    :membership-grade=membershipGrade />
            </div>
        </template>

        <p class="smallText">
            ダウンロードできたプリクラは「アルバム」に追加されます。
        </p>
        <normal-btn @click="onAlbum">アルバムを見る</normal-btn>
        <p v-if="membershipGrade === 1" class="smallText">
            残りのプリクラは有料会員になるとダウンロードできます<br>
            保存期間が過ぎたプリクラはダウンロードできなくなります
        </p>

        <template v-if="membershipGrade === 1">
            <div class="puriBottomWrapper">
                <div class="gimmiTopWrapper">
                    <div class="guidance">
                        <normal-btn @click="onMemberBenefits">詳しく見る</normal-btn>
                    </div>
                    <div class="limit">
                        <div class="limit__header">
                            <div class="limit__headerIcon" />
                            <span class="limit__headerText">保存期間</span>
                        </div>
                        <div v-if="limitDate" class="limit__remainingDay">
                            <span class="limit__remainingDaytext">残り{{ limitDateStr }}日</span>
                        </div>
                    </div>
                </div>
                <div class="gimmiBottomWrapper">
                    <puri-contents-bottom v-if="sheets && sheets.length > 0"
                        :contents=contents
                        :not-selected-contents="notSelectedContents"
                    />
                </div>
            </div>
        </template>
        <sub-btn @click="onBack">プリダウンロードに戻る</sub-btn>
    </div>
</template>

<script>
import NormalBtn from '@/components/NormalBtn.vue'
import SectionHeader from '../components/SectionHeader.vue'
import SubBtn from '../components/SubBtn.vue'
import PuriSheet from '../components/PuriSheet'
import PuriContentsTop from '@/components/PuriContentsTop.vue';
import PuriContentsBottom from '@/components/PuriContentsBottom.vue';
import Protobuf from '../mixins/protobuf'
import { splitArray, daysLeft } from "../assets/js/util";

const pb = require('../assets/js/kumaproto').kuma.jp.protobuf.web
const pbc = require('../assets/js/kumaproto').kuma.jp.protobuf.common
const ROW_MAX = 10

export default {
    name: "AlreadyDownloaded",
    components: { SectionHeader, PuriSheet, PuriContentsTop, PuriContentsBottom, NormalBtn, SubBtn},
    mixins: [Protobuf],
    data() {
        return {
            sheetId: '',
            sheets: [],
            logoList: null,
            membershipGrade: -1,
            limitDate: null,
            arcadeName: '',
            createDate: null,
            arcadeLogoImg: null,
            contents: [],
            tmpContents: [],
            selectedContents: [],
            notSelectedContents: [],
        }
    },
    watch: {
        tmpContents(v) {
            if (v.length === this.sheets[0].puriList.length) {
                this.contents = v.concat().sort((a, b) => a.seqIndex - b.seqIndex)
                this.selectedContents = this.contents.filter(element => element.selected)
                this.notSelectedContents = this.contents.filter(element => !element.selected)
            }
        }
    },
    computed: {
        sheetsList() {
            const arr = this.sheets
            arr.sort((a, b) => a.limitDate > b.limitDate ? 1 : -1)
            return splitArray(arr, ROW_MAX)
        },
        limitDateStr() {
            return daysLeft(this.limitDate)
        }
    },
    methods: {
        getLogoList() {
            const cmdNo = pb.KumaMasterSettingReq.CommandNo.COMMAND_NO
            const message = pb.KumaMasterSettingReq.create()
            const encoded = pb.KumaMasterSettingReq.encode(message).finish()
            this.post(cmdNo, encoded)
            .then(decoded => {
                this.logoList = decoded.masterArcadeList
            })
        },
        // 無料会員のシート情報取得
        getFreeMemberSheet() {
            // 無料会員は保存期限が必要なのでSheetListReq
            const cmdNo = pb.SheetListReq.CommandNo.COMMAND_NO
            const message = pb.SheetListReq.create()
            const encoded = pb.SheetListReq.encode(message).finish()
            this.post(cmdNo, encoded)
                .then(decoded => {
                if (decoded === undefined || decoded.sheetList === undefined) {
                    this.$_error('Error', { title: 'プリダウンロード', statusCode: 100 })
                    return
                }
                const targetPuriInfo = decoded.sheetList.filter(element => element.id === Number(this.$store.state.targetPuriId))
                if(targetPuriInfo.length > 0){
                    targetPuriInfo.sort((a, b) => {return a.limitDate - b.limitDate}).forEach(sheet => {
                        const cmdNo = pb.PuriContentListReq.CommandNo.COMMAND_NO
                        const message = pb.PuriContentListReq.create({
                            id: sheet.id
                        })
                        const encoded = pb.PuriContentListReq.encode(message).finish()
                        return this.post(cmdNo, encoded)
                        .then(decoded => {
                            const targetArcade = this.logoList.find(item => item.name === sheet.arcadeName)
                            if(targetArcade && targetArcade.arcadeLogoImg){
                                this.sheets.push({
                                    id: sheet.id,
                                    arcadeName: sheet.arcadeName,
                                    createDate: sheet.createDate,
                                    limitDate: sheet.limitDate,
                                    puriList: decoded.puriList,
                                    arcadeLogoImg: targetArcade.arcadeLogoImg
                                })
                                this.limitDate = this.sheets[0].limitDate
                                this.arcadeName = this.sheets[0].arcadeName
                                this.createDate = this.sheets[0].createDate
                                this.arcadeLogoImg = targetArcade.arcadeLogoImg
                            }
                            this.getPuriLists()
                        }).catch(() => {
                            this.$_error('Error', { title: 'プリダウンロード', statusCode: 420 })
                        })
                    })
                } else {
                    // 該当プリがなければプリ一覧へ
                    this.$router.replace('/download')
                    return
                }
            })
            .catch(() => {
                this.$_error('Error', { title: 'プリダウンロード', statusCode: 420 })
            })
        },
        // 有料会員のシート情報取得
        async getPaidMemberSheet() {
            // 有料会員はSheetListRespが空の配列を返すのでAlbumPuriListReq
            const albumCmdNo = pb.AlbumPuriListReq.CommandNo.COMMAND_NO
            const albumMessage = pb.AlbumPuriListReq.create()
            const albumEncoded = pb.AlbumPuriListReq.encode(albumMessage).finish()
            this.post(albumCmdNo, albumEncoded)
                .then(decoded => {
                    if (decoded === undefined || decoded.items === undefined) {
                        this.$_error('Error', { title: 'プリダウンロード', statusCode: 100 })
                        return
                    }
                    const targetPuriInfo = decoded.items.find(element => element.sheetId === Number(this.$store.state.targetPuriId))
                    if(targetPuriInfo){
                        const cmdNo = pb.PuriContentListReq.CommandNo.COMMAND_NO
                        const message = pb.PuriContentListReq.create({
                            id: targetPuriInfo.sheetId
                        })
                        const encoded = pb.PuriContentListReq.encode(message).finish()
                        return this.post(cmdNo, encoded)
                        .then(decoded => {
                            const targetArcade = this.logoList.find(item => item.name === targetPuriInfo.arcadeName)
                            if(targetArcade && targetArcade.arcadeLogoImg){
                                this.sheets.push({
                                    id: targetPuriInfo.sheetId,
                                    arcadeName: targetPuriInfo.arcadeName,
                                    createDate: targetPuriInfo.time,
                                    limitDate: 0, // 有料会員の時、limitDateは表示されないので0
                                    puriList: decoded.puriList,
                                    arcadeLogoImg: targetArcade.arcadeLogoImg
                                })
                            }
                            this.getPuriLists()
                        }).catch(() => {
                            this.$_error('Error', { title: 'プリダウンロード', statusCode: 420 })
                        })
                    } else {
                        // 該当プリがなければプリ一覧へ
                        this.$router.replace('/download')
                        return
                    }
            })
            .catch(() => {
                this.$_error('Error', { title: 'プリダウンロード', statusCode: 420 })
            })
        },
        // ユーザーの会員情報取得
        getMembershipGrade(){
            const cmdNo = pb.PlayerInfoReq.CommandNo.COMMAND_NO
            const message = pb.PlayerInfoReq.create()
            const encoded = pb.PlayerInfoReq.encode(message).finish()
            this.post(cmdNo, encoded).then(decoded => {
                this.membershipGrade = decoded.membershipGrade
                this.sheets = []
                this.getLogoList()

                if(this.$store.state.targetPuriId && this.membershipGrade === 1){
                    this.getFreeMemberSheet()
                }else if(this.$store.state.targetPuriId && this.membershipGrade >= 2){
                    this.getPaidMemberSheet()
                } else {
                    this.$router.push('/download')
                }
            });
        },
        onAlbum() {
            this.$router.push('/album')
        },
        onMemberBenefits() {
            this.$router.push('/MemberBenefits')
        },
        async getPuriLists(){
            const requests = []
            const image = pbc.PuriContentType.THUMBNAIL
            const imageBase = pbc.PuriContentType.THUMBNAIL_BASE
            const cmdNo = pb.PuriContentReq.CommandNo.COMMAND_NO

            const puriList = this.sheets[0].puriList;

            puriList.forEach(d => {
                let types;
                if(d.surpriseShot2){
                    types = imageBase
                } else {
                    types = image
                }
                const message = pb.PuriContentReq.create({
                    id: d.id,
                    types: [types]
                })
                const encoded = pb.PuriContentReq.encode(message).finish()
                requests.push(this.post(cmdNo, encoded))
            })
            const decodes = await Promise.all(requests)

            decodes.forEach((d, i) => {
                let bytes;
                if(puriList[i].surpriseShot2){
                    bytes = d.contents[imageBase]
                } else {
                    bytes = d.contents[image]
                }
                this.tmpContents.push({
                    bytes: bytes,
                    selected: puriList[i].selected || !this.$store.getters.isFreeMembership,
                    seqIndex: puriList[i].seqIndex,
                    hasgraff: d.hasgraff,
                    surpriseShot: puriList[i].surpriseShot,
                    surpriseShot2: puriList[i].surpriseShot2
                })
            })
        },
        onBack() {
            this.$router.push('/download')
        },
    },
    mounted() {
        this.getMembershipGrade()
    },
}
</script>

<style lang="scss" scoped>
.puriTopWrapper {
    display: flex;
    justify-content: center;
    margin: 0 15px;
}
.--marginTop {
    margin-top: 25px;
}

.NormalBtn {
    margin-top: 15px;
}
.smallText {
    margin: 15px 15px 0;
    font-size: 12px;
}

.--moreMarginTop {
    margin-top: 30px;
}

.puriBottomWrapper {
    width: calc(100% - 30px);
    display: flex;
    height: fit-content;
    margin: 20px auto;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    .gimmiTopWrapper,
    .gimmiBottomWrapper {
        margin: 0 auto;
    }
    .gimmiTopWrapper {
        width: 100%;
        .guidance {
            width: 100%;
            margin: 0;
            text-align: center;
            &__text {
                font-size: 12px;
            }
            .NormalBtn {
                margin: 0;
            }
        }
        .limit {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 20px;
            &__header {
                display: flex;
                justify-content: center;
                align-items: center;
                color: #F63C5B;
            }
            &__headerIcon {
                width: 18px;
                height: 18px;
                background-image: url(../assets/Png/Common/ic_exclamation_pink.png);
                background-size: contain;
                background-position: 0;
            }
            &__headerText {
                font-size: 12px;
                margin-left: 5px;
            }
            &__remainingDaytext {
                font-size: 28px;
                color: #F63C5B;
                margin-left: 40px;
            }
        }
    }
}
</style>